<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">                 
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<div class="container-fluid container-list">

    <app-panelproductos-filter [listTiposErroresProductos]="listTiposErroresProductos" [lastFilter]="payload" (search)="onSearch($event)" (cleanForm)="onReset()"></app-panelproductos-filter>

    <app-panelproductos-list *ngIf="searching" [result]="result" [lastFilter]="payload" (search)="onSearchLazy($event)" (edit)="onEdit($event)" (marcaAltaTraces)="onMarcaAltaTraces($event)" (delete)="onDelete($event)"></app-panelproductos-list>

</div>
